/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MstCenterStockItem
 */
export interface MstCenterStockItem {
    /**
     * 
     * @type {boolean}
     * @memberof MstCenterStockItem
     */
    deleteFlg: boolean | null;
    /**
     * 
     * @type {Date}
     * @memberof MstCenterStockItem
     */
    insertDatetime: Date | null;
    /**
     * 
     * @type {string}
     * @memberof MstCenterStockItem
     */
    insertUser: string | null;
    /**
     * 
     * @type {Date}
     * @memberof MstCenterStockItem
     */
    updateDatetime: Date | null;
    /**
     * 
     * @type {string}
     * @memberof MstCenterStockItem
     */
    updateUser: string | null;
    /**
     * 
     * @type {Date}
     * @memberof MstCenterStockItem
     */
    deleteDatetime: Date | null;
    /**
     * 
     * @type {string}
     * @memberof MstCenterStockItem
     */
    deleteUser: string | null;
    /**
     * 
     * @type {number}
     * @memberof MstCenterStockItem
     */
    companyId: number | null;
    /**
     * 
     * @type {number}
     * @memberof MstCenterStockItem
     */
    centerId: number | null;
    /**
     * 
     * @type {string}
     * @memberof MstCenterStockItem
     */
    orgCenterId: string | null;
    /**
     * 
     * @type {string}
     * @memberof MstCenterStockItem
     */
    orgItemCode: string | null;
    /**
     * 
     * @type {string}
     * @memberof MstCenterStockItem
     */
    orgSupplierId: string | null;
    /**
     * 
     * @type {number}
     * @memberof MstCenterStockItem
     */
    stockDaysSetting: number | null;
    /**
     * 
     * @type {number}
     * @memberof MstCenterStockItem
     */
    safetyStockSetting: number | null;
    /**
     * 
     * @type {number}
     * @memberof MstCenterStockItem
     */
    minStockQuantity: number | null;
    /**
     * 
     * @type {string}
     * @memberof MstCenterStockItem
     */
    orderUnitType: string | null;
    /**
     * 
     * @type {number}
     * @memberof MstCenterStockItem
     */
    caseLot: number | null;
    /**
     * 
     * @type {number}
     * @memberof MstCenterStockItem
     */
    minOrderQuantity: number | null;
    /**
     * 
     * @type {Date}
     * @memberof MstCenterStockItem
     */
    startDate: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof MstCenterStockItem
     */
    stopShip: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MstCenterStockItem
     */
    stopArrival: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MstCenterStockItem
     */
    isDiscontinued: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MstCenterStockItem
     */
    isMuted: boolean | null;
    /**
     * 
     * @type {Date}
     * @memberof MstCenterStockItem
     */
    salesEndAlertDate: Date | null;
    /**
     * 
     * @type {string}
     * @memberof MstCenterStockItem
     */
    remarks: string | null;
    /**
     * 
     * @type {string}
     * @memberof MstCenterStockItem
     */
    trOrgSupplierId: string | null;
    /**
     * 
     * @type {number}
     * @memberof MstCenterStockItem
     */
    trStockDaysSetting: number | null;
    /**
     * 
     * @type {number}
     * @memberof MstCenterStockItem
     */
    trSafetyStockSetting: number | null;
    /**
     * 
     * @type {string}
     * @memberof MstCenterStockItem
     */
    trOrderUnitType: string | null;
    /**
     * 
     * @type {Date}
     * @memberof MstCenterStockItem
     */
    trStartDate: Date | null;
    /**
     * 
     * @type {string}
     * @memberof MstCenterStockItem
     */
    itemCode: string | null;
    /**
     * 
     * @type {string}
     * @memberof MstCenterStockItem
     */
    orgItemCodeRecency: string | null;
    /**
     * 
     * @type {string}
     * @memberof MstCenterStockItem
     */
    mstItemItemName: string | null;
    /**
     * 
     * @type {Date}
     * @memberof MstCenterStockItem
     */
    mstItemSalesStartdate: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof MstCenterStockItem
     */
    mstItemSalesEnddate: Date | null;
    /**
     * 
     * @type {number}
     * @memberof MstCenterStockItem
     */
    mstItemLongside: number | null;
    /**
     * 
     * @type {number}
     * @memberof MstCenterStockItem
     */
    mstItemShortside: number | null;
    /**
     * 
     * @type {number}
     * @memberof MstCenterStockItem
     */
    mstItemHeight: number | null;
    /**
     * 
     * @type {number}
     * @memberof MstCenterStockItem
     */
    mstItemWeight: number | null;
    /**
     * 
     * @type {string}
     * @memberof MstCenterStockItem
     */
    mstItemSpec: string | null;
    /**
     * 
     * @type {number}
     * @memberof MstCenterStockItem
     */
    mstItemMaxPalletQuantity: number | null;
    /**
     * 
     * @type {number}
     * @memberof MstCenterStockItem
     */
    mstItemPalletQuantityFace: number | null;
    /**
     * 
     * @type {number}
     * @memberof MstCenterStockItem
     */
    mstItemPalletQuantityTier: number | null;
    /**
     * 
     * @type {string}
     * @memberof MstCenterStockItem
     */
    mstItemReplaceItemCode: string | null;
    /**
     * 
     * @type {string}
     * @memberof MstCenterStockItem
     */
    mstItemMakerName: string | null;
    /**
     * 
     * @type {string}
     * @memberof MstCenterStockItem
     */
    mstItemJan: string | null;
    /**
     * 
     * @type {string}
     * @memberof MstCenterStockItem
     */
    mstItemJanCase: string | null;
    /**
     * 
     * @type {string}
     * @memberof MstCenterStockItem
     */
    mstItemGtin13: string | null;
    /**
     * 
     * @type {string}
     * @memberof MstCenterStockItem
     */
    mstItemGtin14: string | null;
    /**
     * 
     * @type {string}
     * @memberof MstCenterStockItem
     */
    mstItemItf: string | null;
    /**
     * 
     * @type {string}
     * @memberof MstCenterStockItem
     */
    mstItemOrgSupplierId: string | null;
    /**
     * 
     * @type {string}
     * @memberof MstCenterStockItem
     */
    mstItemSupplierName: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof MstCenterStockItem
     */
    mstItemDeleteFlg: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MstCenterStockItem
     */
    mstItemIsDiscontinued: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MstCenterStockItem
     */
    mstItemIsMuted: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MstCenterStockItem
     */
    recencyFlg: boolean | null;
    /**
     * 
     * @type {Date}
     * @memberof MstCenterStockItem
     */
    endDate: Date | null;
    /**
     * 
     * @type {string}
     * @memberof MstCenterStockItem
     */
    prevOrgItemCode: string | null;
    /**
     * 
     * @type {string}
     * @memberof MstCenterStockItem
     */
    nextOrgItemCode: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof MstCenterStockItem
     */
    centerTargetItemFlg: boolean | null;
    /**
     * 
     * @type {Date}
     * @memberof MstCenterStockItem
     */
    lastArrivalDate: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof MstCenterStockItem
     */
    lastShipDate: Date | null;
    /**
     * 
     * @type {number}
     * @memberof MstCenterStockItem
     */
    lastStockQuantity: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof MstCenterStockItem
     */
    masterNotFound: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MstCenterStockItem
     */
    isInactive: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MstCenterStockItem
     */
    unmatchLot: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MstCenterStockItem
     */
    unmatchStockdays: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MstCenterStockItem
     */
    unmatchRenewal: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof MstCenterStockItem
     */
    alertMessage: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof MstCenterStockItem
     */
    isExpectedRankAlert: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MstCenterStockItem
     */
    isMinShipDateAlert: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MstCenterStockItem
     */
    isEndSaleAlert: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MstCenterStockItem
     */
    isAlertMaster: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MstCenterStockItem
     */
    isAlert: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof MstCenterStockItem
     */
    alertType: string | null;
    /**
     * 
     * @type {string}
     * @memberof MstCenterStockItem
     */
    alertTypeName: string | null;
    /**
     * 
     * @type {number}
     * @memberof MstCenterStockItem
     */
    supplierCompanyId: number | null;
    /**
     * 
     * @type {string}
     * @memberof MstCenterStockItem
     */
    transportOrgCenterId: string | null;
    /**
     * 
     * @type {string}
     * @memberof MstCenterStockItem
     */
    supplierName: string | null;
    /**
     * 
     * @type {string}
     * @memberof MstCenterStockItem
     */
    orderLimitTime: string | null;
    /**
     * 
     * @type {number}
     * @memberof MstCenterStockItem
     */
    trCaseLot: number | null;
    /**
     * 
     * @type {string}
     * @memberof MstCenterStockItem
     */
    orderUnitTypeName: string | null;
    /**
     * 
     * @type {string}
     * @memberof MstCenterStockItem
     */
    trOptimizeType: string | null;
    /**
     * 
     * @type {string}
     * @memberof MstCenterStockItem
     */
    trOptimizeRange: string | null;
    /**
     * 
     * @type {number}
     * @memberof MstCenterStockItem
     */
    trOrderLeadtime: number | null;
    /**
     * 
     * @type {number}
     * @memberof MstCenterStockItem
     */
    trMinOrderQuantityOnce: number | null;
    /**
     * 
     * @type {number}
     * @memberof MstCenterStockItem
     */
    trMinOrderQuantity: number | null;
    /**
     * 
     * @type {number}
     * @memberof MstCenterStockItem
     */
    trMinStockQuantity: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof MstCenterStockItem
     */
    trStopArrival: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MstCenterStockItem
     */
    trDeleteFlg: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MstCenterStockItem
     */
    trIsDiscontinued: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof MstCenterStockItem
     */
    expectedRank: number | null;
}

/**
 * Check if a given object implements the MstCenterStockItem interface.
 */
export function instanceOfMstCenterStockItem(value: object): value is MstCenterStockItem {
    if (!('deleteFlg' in value) || value['deleteFlg'] === undefined) return false;
    if (!('insertDatetime' in value) || value['insertDatetime'] === undefined) return false;
    if (!('insertUser' in value) || value['insertUser'] === undefined) return false;
    if (!('updateDatetime' in value) || value['updateDatetime'] === undefined) return false;
    if (!('updateUser' in value) || value['updateUser'] === undefined) return false;
    if (!('deleteDatetime' in value) || value['deleteDatetime'] === undefined) return false;
    if (!('deleteUser' in value) || value['deleteUser'] === undefined) return false;
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    if (!('centerId' in value) || value['centerId'] === undefined) return false;
    if (!('orgCenterId' in value) || value['orgCenterId'] === undefined) return false;
    if (!('orgItemCode' in value) || value['orgItemCode'] === undefined) return false;
    if (!('orgSupplierId' in value) || value['orgSupplierId'] === undefined) return false;
    if (!('stockDaysSetting' in value) || value['stockDaysSetting'] === undefined) return false;
    if (!('safetyStockSetting' in value) || value['safetyStockSetting'] === undefined) return false;
    if (!('minStockQuantity' in value) || value['minStockQuantity'] === undefined) return false;
    if (!('orderUnitType' in value) || value['orderUnitType'] === undefined) return false;
    if (!('caseLot' in value) || value['caseLot'] === undefined) return false;
    if (!('minOrderQuantity' in value) || value['minOrderQuantity'] === undefined) return false;
    if (!('startDate' in value) || value['startDate'] === undefined) return false;
    if (!('stopShip' in value) || value['stopShip'] === undefined) return false;
    if (!('stopArrival' in value) || value['stopArrival'] === undefined) return false;
    if (!('isDiscontinued' in value) || value['isDiscontinued'] === undefined) return false;
    if (!('isMuted' in value) || value['isMuted'] === undefined) return false;
    if (!('salesEndAlertDate' in value) || value['salesEndAlertDate'] === undefined) return false;
    if (!('remarks' in value) || value['remarks'] === undefined) return false;
    if (!('trOrgSupplierId' in value) || value['trOrgSupplierId'] === undefined) return false;
    if (!('trStockDaysSetting' in value) || value['trStockDaysSetting'] === undefined) return false;
    if (!('trSafetyStockSetting' in value) || value['trSafetyStockSetting'] === undefined) return false;
    if (!('trOrderUnitType' in value) || value['trOrderUnitType'] === undefined) return false;
    if (!('trStartDate' in value) || value['trStartDate'] === undefined) return false;
    if (!('itemCode' in value) || value['itemCode'] === undefined) return false;
    if (!('orgItemCodeRecency' in value) || value['orgItemCodeRecency'] === undefined) return false;
    if (!('mstItemItemName' in value) || value['mstItemItemName'] === undefined) return false;
    if (!('mstItemSalesStartdate' in value) || value['mstItemSalesStartdate'] === undefined) return false;
    if (!('mstItemSalesEnddate' in value) || value['mstItemSalesEnddate'] === undefined) return false;
    if (!('mstItemLongside' in value) || value['mstItemLongside'] === undefined) return false;
    if (!('mstItemShortside' in value) || value['mstItemShortside'] === undefined) return false;
    if (!('mstItemHeight' in value) || value['mstItemHeight'] === undefined) return false;
    if (!('mstItemWeight' in value) || value['mstItemWeight'] === undefined) return false;
    if (!('mstItemSpec' in value) || value['mstItemSpec'] === undefined) return false;
    if (!('mstItemMaxPalletQuantity' in value) || value['mstItemMaxPalletQuantity'] === undefined) return false;
    if (!('mstItemPalletQuantityFace' in value) || value['mstItemPalletQuantityFace'] === undefined) return false;
    if (!('mstItemPalletQuantityTier' in value) || value['mstItemPalletQuantityTier'] === undefined) return false;
    if (!('mstItemReplaceItemCode' in value) || value['mstItemReplaceItemCode'] === undefined) return false;
    if (!('mstItemMakerName' in value) || value['mstItemMakerName'] === undefined) return false;
    if (!('mstItemJan' in value) || value['mstItemJan'] === undefined) return false;
    if (!('mstItemJanCase' in value) || value['mstItemJanCase'] === undefined) return false;
    if (!('mstItemGtin13' in value) || value['mstItemGtin13'] === undefined) return false;
    if (!('mstItemGtin14' in value) || value['mstItemGtin14'] === undefined) return false;
    if (!('mstItemItf' in value) || value['mstItemItf'] === undefined) return false;
    if (!('mstItemOrgSupplierId' in value) || value['mstItemOrgSupplierId'] === undefined) return false;
    if (!('mstItemSupplierName' in value) || value['mstItemSupplierName'] === undefined) return false;
    if (!('mstItemDeleteFlg' in value) || value['mstItemDeleteFlg'] === undefined) return false;
    if (!('mstItemIsDiscontinued' in value) || value['mstItemIsDiscontinued'] === undefined) return false;
    if (!('mstItemIsMuted' in value) || value['mstItemIsMuted'] === undefined) return false;
    if (!('recencyFlg' in value) || value['recencyFlg'] === undefined) return false;
    if (!('endDate' in value) || value['endDate'] === undefined) return false;
    if (!('prevOrgItemCode' in value) || value['prevOrgItemCode'] === undefined) return false;
    if (!('nextOrgItemCode' in value) || value['nextOrgItemCode'] === undefined) return false;
    if (!('centerTargetItemFlg' in value) || value['centerTargetItemFlg'] === undefined) return false;
    if (!('lastArrivalDate' in value) || value['lastArrivalDate'] === undefined) return false;
    if (!('lastShipDate' in value) || value['lastShipDate'] === undefined) return false;
    if (!('lastStockQuantity' in value) || value['lastStockQuantity'] === undefined) return false;
    if (!('masterNotFound' in value) || value['masterNotFound'] === undefined) return false;
    if (!('isInactive' in value) || value['isInactive'] === undefined) return false;
    if (!('unmatchLot' in value) || value['unmatchLot'] === undefined) return false;
    if (!('unmatchStockdays' in value) || value['unmatchStockdays'] === undefined) return false;
    if (!('unmatchRenewal' in value) || value['unmatchRenewal'] === undefined) return false;
    if (!('alertMessage' in value) || value['alertMessage'] === undefined) return false;
    if (!('isExpectedRankAlert' in value) || value['isExpectedRankAlert'] === undefined) return false;
    if (!('isMinShipDateAlert' in value) || value['isMinShipDateAlert'] === undefined) return false;
    if (!('isEndSaleAlert' in value) || value['isEndSaleAlert'] === undefined) return false;
    if (!('isAlertMaster' in value) || value['isAlertMaster'] === undefined) return false;
    if (!('isAlert' in value) || value['isAlert'] === undefined) return false;
    if (!('alertType' in value) || value['alertType'] === undefined) return false;
    if (!('alertTypeName' in value) || value['alertTypeName'] === undefined) return false;
    if (!('supplierCompanyId' in value) || value['supplierCompanyId'] === undefined) return false;
    if (!('transportOrgCenterId' in value) || value['transportOrgCenterId'] === undefined) return false;
    if (!('supplierName' in value) || value['supplierName'] === undefined) return false;
    if (!('orderLimitTime' in value) || value['orderLimitTime'] === undefined) return false;
    if (!('trCaseLot' in value) || value['trCaseLot'] === undefined) return false;
    if (!('orderUnitTypeName' in value) || value['orderUnitTypeName'] === undefined) return false;
    if (!('trOptimizeType' in value) || value['trOptimizeType'] === undefined) return false;
    if (!('trOptimizeRange' in value) || value['trOptimizeRange'] === undefined) return false;
    if (!('trOrderLeadtime' in value) || value['trOrderLeadtime'] === undefined) return false;
    if (!('trMinOrderQuantityOnce' in value) || value['trMinOrderQuantityOnce'] === undefined) return false;
    if (!('trMinOrderQuantity' in value) || value['trMinOrderQuantity'] === undefined) return false;
    if (!('trMinStockQuantity' in value) || value['trMinStockQuantity'] === undefined) return false;
    if (!('trStopArrival' in value) || value['trStopArrival'] === undefined) return false;
    if (!('trDeleteFlg' in value) || value['trDeleteFlg'] === undefined) return false;
    if (!('trIsDiscontinued' in value) || value['trIsDiscontinued'] === undefined) return false;
    if (!('expectedRank' in value) || value['expectedRank'] === undefined) return false;
    return true;
}

export function MstCenterStockItemFromJSON(json: any): MstCenterStockItem {
    return MstCenterStockItemFromJSONTyped(json, false);
}

export function MstCenterStockItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): MstCenterStockItem {
    if (json == null) {
        return json;
    }
    return {
        
        'deleteFlg': json['delete_flg'],
        'insertDatetime': (json['insert_datetime'] == null ? null : new Date(json['insert_datetime'])),
        'insertUser': json['insert_user'],
        'updateDatetime': (json['update_datetime'] == null ? null : new Date(json['update_datetime'])),
        'updateUser': json['update_user'],
        'deleteDatetime': (json['delete_datetime'] == null ? null : new Date(json['delete_datetime'])),
        'deleteUser': json['delete_user'],
        'companyId': json['company_id'],
        'centerId': json['center_id'],
        'orgCenterId': json['org_center_id'],
        'orgItemCode': json['org_item_code'],
        'orgSupplierId': json['org_supplier_id'],
        'stockDaysSetting': json['stock_days_setting'],
        'safetyStockSetting': json['safety_stock_setting'],
        'minStockQuantity': json['min_stock_quantity'],
        'orderUnitType': json['order_unit_type'],
        'caseLot': json['case_lot'],
        'minOrderQuantity': json['min_order_quantity'],
        'startDate': (json['start_date'] == null ? null : new Date(json['start_date'])),
        'stopShip': json['stop_ship'],
        'stopArrival': json['stop_arrival'],
        'isDiscontinued': json['is_discontinued'],
        'isMuted': json['is_muted'],
        'salesEndAlertDate': (json['sales_end_alert_date'] == null ? null : new Date(json['sales_end_alert_date'])),
        'remarks': json['remarks'],
        'trOrgSupplierId': json['tr_org_supplier_id'],
        'trStockDaysSetting': json['tr_stock_days_setting'],
        'trSafetyStockSetting': json['tr_safety_stock_setting'],
        'trOrderUnitType': json['tr_order_unit_type'],
        'trStartDate': (json['tr_start_date'] == null ? null : new Date(json['tr_start_date'])),
        'itemCode': json['item_code'],
        'orgItemCodeRecency': json['org_item_code_recency'],
        'mstItemItemName': json['mst_item_item_name'],
        'mstItemSalesStartdate': (json['mst_item_sales_startdate'] == null ? null : new Date(json['mst_item_sales_startdate'])),
        'mstItemSalesEnddate': (json['mst_item_sales_enddate'] == null ? null : new Date(json['mst_item_sales_enddate'])),
        'mstItemLongside': json['mst_item_longside'],
        'mstItemShortside': json['mst_item_shortside'],
        'mstItemHeight': json['mst_item_height'],
        'mstItemWeight': json['mst_item_weight'],
        'mstItemSpec': json['mst_item_spec'],
        'mstItemMaxPalletQuantity': json['mst_item_max_pallet_quantity'],
        'mstItemPalletQuantityFace': json['mst_item_pallet_quantity_face'],
        'mstItemPalletQuantityTier': json['mst_item_pallet_quantity_tier'],
        'mstItemReplaceItemCode': json['mst_item_replace_item_code'],
        'mstItemMakerName': json['mst_item_maker_name'],
        'mstItemJan': json['mst_item_jan'],
        'mstItemJanCase': json['mst_item_jan_case'],
        'mstItemGtin13': json['mst_item_gtin_13'],
        'mstItemGtin14': json['mst_item_gtin_14'],
        'mstItemItf': json['mst_item_itf'],
        'mstItemOrgSupplierId': json['mst_item_org_supplier_id'],
        'mstItemSupplierName': json['mst_item_supplier_name'],
        'mstItemDeleteFlg': json['mst_item_delete_flg'],
        'mstItemIsDiscontinued': json['mst_item_is_discontinued'],
        'mstItemIsMuted': json['mst_item_is_muted'],
        'recencyFlg': json['recency_flg'],
        'endDate': (json['end_date'] == null ? null : new Date(json['end_date'])),
        'prevOrgItemCode': json['prev_org_item_code'],
        'nextOrgItemCode': json['next_org_item_code'],
        'centerTargetItemFlg': json['center_target_item_flg'],
        'lastArrivalDate': (json['last_arrival_date'] == null ? null : new Date(json['last_arrival_date'])),
        'lastShipDate': (json['last_ship_date'] == null ? null : new Date(json['last_ship_date'])),
        'lastStockQuantity': json['last_stock_quantity'],
        'masterNotFound': json['master_not_found'],
        'isInactive': json['is_inactive'],
        'unmatchLot': json['unmatch_lot'],
        'unmatchStockdays': json['unmatch_stockdays'],
        'unmatchRenewal': json['unmatch_renewal'],
        'alertMessage': json['alert_message'],
        'isExpectedRankAlert': json['is_expected_rank_alert'],
        'isMinShipDateAlert': json['is_min_ship_date_alert'],
        'isEndSaleAlert': json['is_end_sale_alert'],
        'isAlertMaster': json['is_alert_master'],
        'isAlert': json['is_alert'],
        'alertType': json['alert_type'],
        'alertTypeName': json['alert_type_name'],
        'supplierCompanyId': json['supplier_company_id'],
        'transportOrgCenterId': json['transport_org_center_id'],
        'supplierName': json['supplier_name'],
        'orderLimitTime': json['order_limit_time'],
        'trCaseLot': json['tr_case_lot'],
        'orderUnitTypeName': json['order_unit_type_name'],
        'trOptimizeType': json['tr_optimize_type'],
        'trOptimizeRange': json['tr_optimize_range'],
        'trOrderLeadtime': json['tr_order_leadtime'],
        'trMinOrderQuantityOnce': json['tr_min_order_quantity_once'],
        'trMinOrderQuantity': json['tr_min_order_quantity'],
        'trMinStockQuantity': json['tr_min_stock_quantity'],
        'trStopArrival': json['tr_stop_arrival'],
        'trDeleteFlg': json['tr_delete_flg'],
        'trIsDiscontinued': json['tr_is_discontinued'],
        'expectedRank': json['expected_rank'],
    };
}

export function MstCenterStockItemToJSON(json: any): MstCenterStockItem {
    return MstCenterStockItemToJSONTyped(json, false);
}

export function MstCenterStockItemToJSONTyped(value?: MstCenterStockItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'delete_flg': value['deleteFlg'],
        'insert_datetime': value['insertDatetime'] == null ? value['insertDatetime'] : value['insertDatetime'].toISOString(),
        'insert_user': value['insertUser'],
        'update_datetime': value['updateDatetime'] == null ? value['updateDatetime'] : value['updateDatetime'].toISOString(),
        'update_user': value['updateUser'],
        'delete_datetime': value['deleteDatetime'] == null ? value['deleteDatetime'] : value['deleteDatetime'].toISOString(),
        'delete_user': value['deleteUser'],
        'company_id': value['companyId'],
        'center_id': value['centerId'],
        'org_center_id': value['orgCenterId'],
        'org_item_code': value['orgItemCode'],
        'org_supplier_id': value['orgSupplierId'],
        'stock_days_setting': value['stockDaysSetting'],
        'safety_stock_setting': value['safetyStockSetting'],
        'min_stock_quantity': value['minStockQuantity'],
        'order_unit_type': value['orderUnitType'],
        'case_lot': value['caseLot'],
        'min_order_quantity': value['minOrderQuantity'],
        'start_date': value['startDate'] == null ? value['startDate'] : value['startDate'].toISOString(),
        'stop_ship': value['stopShip'],
        'stop_arrival': value['stopArrival'],
        'is_discontinued': value['isDiscontinued'],
        'is_muted': value['isMuted'],
        'sales_end_alert_date': value['salesEndAlertDate'] == null ? value['salesEndAlertDate'] : value['salesEndAlertDate'].toISOString().substring(0,10),
        'remarks': value['remarks'],
        'tr_org_supplier_id': value['trOrgSupplierId'],
        'tr_stock_days_setting': value['trStockDaysSetting'],
        'tr_safety_stock_setting': value['trSafetyStockSetting'],
        'tr_order_unit_type': value['trOrderUnitType'],
        'tr_start_date': value['trStartDate'] == null ? value['trStartDate'] : value['trStartDate'].toISOString(),
        'item_code': value['itemCode'],
        'org_item_code_recency': value['orgItemCodeRecency'],
        'mst_item_item_name': value['mstItemItemName'],
        'mst_item_sales_startdate': value['mstItemSalesStartdate'] == null ? value['mstItemSalesStartdate'] : value['mstItemSalesStartdate'].toISOString(),
        'mst_item_sales_enddate': value['mstItemSalesEnddate'] == null ? value['mstItemSalesEnddate'] : value['mstItemSalesEnddate'].toISOString(),
        'mst_item_longside': value['mstItemLongside'],
        'mst_item_shortside': value['mstItemShortside'],
        'mst_item_height': value['mstItemHeight'],
        'mst_item_weight': value['mstItemWeight'],
        'mst_item_spec': value['mstItemSpec'],
        'mst_item_max_pallet_quantity': value['mstItemMaxPalletQuantity'],
        'mst_item_pallet_quantity_face': value['mstItemPalletQuantityFace'],
        'mst_item_pallet_quantity_tier': value['mstItemPalletQuantityTier'],
        'mst_item_replace_item_code': value['mstItemReplaceItemCode'],
        'mst_item_maker_name': value['mstItemMakerName'],
        'mst_item_jan': value['mstItemJan'],
        'mst_item_jan_case': value['mstItemJanCase'],
        'mst_item_gtin_13': value['mstItemGtin13'],
        'mst_item_gtin_14': value['mstItemGtin14'],
        'mst_item_itf': value['mstItemItf'],
        'mst_item_org_supplier_id': value['mstItemOrgSupplierId'],
        'mst_item_supplier_name': value['mstItemSupplierName'],
        'mst_item_delete_flg': value['mstItemDeleteFlg'],
        'mst_item_is_discontinued': value['mstItemIsDiscontinued'],
        'mst_item_is_muted': value['mstItemIsMuted'],
        'recency_flg': value['recencyFlg'],
        'end_date': value['endDate'] == null ? value['endDate'] : value['endDate'].toISOString(),
        'prev_org_item_code': value['prevOrgItemCode'],
        'next_org_item_code': value['nextOrgItemCode'],
        'center_target_item_flg': value['centerTargetItemFlg'],
        'last_arrival_date': value['lastArrivalDate'] == null ? value['lastArrivalDate'] : value['lastArrivalDate'].toISOString(),
        'last_ship_date': value['lastShipDate'] == null ? value['lastShipDate'] : value['lastShipDate'].toISOString(),
        'last_stock_quantity': value['lastStockQuantity'],
        'master_not_found': value['masterNotFound'],
        'is_inactive': value['isInactive'],
        'unmatch_lot': value['unmatchLot'],
        'unmatch_stockdays': value['unmatchStockdays'],
        'unmatch_renewal': value['unmatchRenewal'],
        'alert_message': value['alertMessage'],
        'is_expected_rank_alert': value['isExpectedRankAlert'],
        'is_min_ship_date_alert': value['isMinShipDateAlert'],
        'is_end_sale_alert': value['isEndSaleAlert'],
        'is_alert_master': value['isAlertMaster'],
        'is_alert': value['isAlert'],
        'alert_type': value['alertType'],
        'alert_type_name': value['alertTypeName'],
        'supplier_company_id': value['supplierCompanyId'],
        'transport_org_center_id': value['transportOrgCenterId'],
        'supplier_name': value['supplierName'],
        'order_limit_time': value['orderLimitTime'],
        'tr_case_lot': value['trCaseLot'],
        'order_unit_type_name': value['orderUnitTypeName'],
        'tr_optimize_type': value['trOptimizeType'],
        'tr_optimize_range': value['trOptimizeRange'],
        'tr_order_leadtime': value['trOrderLeadtime'],
        'tr_min_order_quantity_once': value['trMinOrderQuantityOnce'],
        'tr_min_order_quantity': value['trMinOrderQuantity'],
        'tr_min_stock_quantity': value['trMinStockQuantity'],
        'tr_stop_arrival': value['trStopArrival'],
        'tr_delete_flg': value['trDeleteFlg'],
        'tr_is_discontinued': value['trIsDiscontinued'],
        'expected_rank': value['expectedRank'],
    };
}

